
export const MOTIVATIONAL_POPUP_CSS = `
  .motivational-popup {
    transform-origin: center;
    animation: motivational-enter 0.5s ease-out;
  }
  
  .motivational-effect-glitch {
    animation: glitch-animation 0.3s infinite;
  }
  
  .motivational-effect-pulse {
    animation: pulse-animation 2s ease-in-out infinite;
  }
  
  .motivational-effect-shake {
    animation: shake-animation 0.5s ease-in-out infinite;
  }
  
  .motivational-effect-float {
    animation: float-animation 3s ease-in-out infinite;
  }
  
  .motivational-effect-toxic-glow {
    animation: toxic-glow 2s ease-in-out infinite;
  }
  
  .motivational-effect-wave {
    animation: wave-animation 2s ease-in-out infinite;
  }
  
  .motivational-effect-fade-in-out {
    animation: fade-in-out 3s ease-in-out infinite;
  }
  
  .motivational-effect-distort {
    animation: distort-animation 1s ease-in-out infinite;
  }
  
  .motivational-effect-blink {
    animation: blink-animation 1s step-end infinite;
  }
  
  .motivational-effect-static {
    animation: static-animation 0.1s infinite;
  }
  
  @keyframes motivational-enter {
    0% { 
      opacity: 0; 
      transform: scale(0.8) translateY(-20px); 
    }
    100% { 
      opacity: 1; 
      transform: scale(1) translateY(0); 
    }
  }
  
  @keyframes glitch-animation {
    0%, 100% { transform: translate(0); }
    20% { transform: translate(-2px, 2px); }
    40% { transform: translate(-2px, -2px); }
    60% { transform: translate(2px, 2px); }
    80% { transform: translate(2px, -2px); }
  }
  
  @keyframes pulse-animation {
    0%, 100% { box-shadow: 0 0 20px var(--popup-shadow); }
    50% { box-shadow: 0 0 40px var(--popup-shadow), 0 0 60px var(--popup-shadow); }
  }
  
  @keyframes shake-animation {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-5px); }
    75% { transform: translateX(5px); }
  }
  
  @keyframes float-animation {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
  }
  
  @keyframes toxic-glow {
    0%, 100% { filter: brightness(1) saturate(1); }
    50% { filter: brightness(1.2) saturate(1.5) hue-rotate(10deg); }
  }
  
  @keyframes wave-animation {
    0%, 100% { transform: skewX(0deg); }
    25% { transform: skewX(2deg); }
    75% { transform: skewX(-2deg); }
  }
  
  @keyframes fade-in-out {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }
  
  @keyframes distort-animation {
    0%, 100% { transform: scaleX(1); }
    50% { transform: scaleX(0.98) scaleY(1.02); }
  }
  
  @keyframes blink-animation {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0.8; }
  }
  
  @keyframes static-animation {
    0% { filter: contrast(1); }
    50% { filter: contrast(1.1) brightness(1.1); }
    100% { filter: contrast(1); }
  }
`;
